import React, {useState, useRef, useContext} from 'react';
import {Container, Row, Col} from 'reactstrap';
import classes from './Recursos.module.css';

const Recursos = () => {

    return(
        <Container>
            <Row>
                <Col className="title-container">
                    <div>
                        <h1>Recursos</h1>
                        <span>Te invitamos a revisar los siguientes recursos que te ayudarán a mejorar tus habilidades como mentor voluntario:</span>
                    </div>
                </Col>
            </Row>
            <Row className={classes.recursosContainer}>
                <h4>Bienvenida a Soy Mentor</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/KV5wrlaz2QM" frameborder="0"></iframe>
                <h4>Conociendo Soy Mentor (33 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/3I2FmqT0MVo" frameborder="0"></iframe>
                <h4>Mentoría Apreciativa (50 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/alXNFCBNAUQ" frameborder="0"></iframe>
                <h4>NUEVO: Ciclo de vida de la mentoría (2 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/hOFbaL2Ices" frameborder="0"></iframe>
                <h4>NUEVO: Modelo SMART (10 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/T7RgS5Sz6Zs" frameborder="0"></iframe>
                <h4>NUEVO: Identifica cómo es tu mentee (2 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/k7oFn4VMh8U" frameborder="0"></iframe>
                <h4>NUEVO: Las claves para ser un buen mentor (4 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/2Cr1hg68_8M" frameborder="0"></iframe>
                <h4>NUEVO: Tips para ser un buen oyente (2 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/2gORlinI7a4" frameborder="0"></iframe>
                <h4>NUEVO: Técnicas para una comunicación activa (3 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/Pi4firgAAXk" frameborder="0"></iframe>
                <h4>NUEVO: FODA personal (2 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/sUdk309Ep0k" frameborder="0"></iframe>
                <h4>Detección de riesgos y derivación (29 min)</h4>
                <iframe type="text/html" width="640" height="385" src="https://www.youtube.com/embed/31IVioKvzHw" frameborder="0"></iframe>
                <h4>Reta tus conocomientos para ofrecer una mentoría apreciativa:</h4>
                <iframe width="640" height="480" src="https://forms.office.com/Pages/ResponsePage.aspx?id=HZUOA_1u9UKEJ7q2Ms-AEABm_6ty-Z9Fo2ZcsVAOPIpUNEhTVTBBV0xJS043TE44VjhGN1BRMlBFRy4u&amp;embed=true" frameborder="0" marginwidth="0" marginheight="0" style={{border: 'none', maxWidth: '100%', maxHeight: '100vh'}} allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" msallowfullscreen=""> </iframe>
            </Row>
        </Container>
    )
}
export default Recursos;
